/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CalculateBmiDto = {
    /**
     * Gender
     */
    gender: CalculateBmiDto.gender;
    /**
     * Age in years
     */
    age: number;
    /**
     * Height in centimeters
     */
    height_cm: number;
    /**
     * Weight in kilograms
     */
    weight_kg: number;
};
export namespace CalculateBmiDto {
    /**
     * Gender
     */
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
    }
}

